import React from 'react';
import { Flower2, Grape, KeyRound, Lightbulb } from 'lucide-react';
import { getProduct, resolveProductType } from './registry';

const TYPE_STYLES = {
    keyring: 'bg-primary/15 text-primary border-primary/25',
    lightbox: 'bg-secondary/15 text-secondary border-secondary/25',
    napkin_bubble: 'bg-accent/15 text-accent border-accent/25',
    napkin_panel: 'bg-warning/15 text-warning border-warning/25',
};

const TYPE_ICONS = {
    keyring: KeyRound,
    lightbox: Lightbulb,
    napkin_bubble: Grape,
    napkin_panel: Flower2,
};

export const productTypeLabel = (modelo) => {
    const productType = resolveProductType(modelo?.form2d_data);
    return getProduct(productType).label;
};

function ProductTypeBadge({ modelo, compact = false, className = '' }) {
    const productType = resolveProductType(modelo?.form2d_data);
    const product = getProduct(productType);
    const Icon = TYPE_ICONS[productType] || KeyRound;

    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full border font-medium
                        ${compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-[11px]'}
                        ${TYPE_STYLES[productType] || TYPE_STYLES.keyring}
                        backdrop-blur-sm whitespace-nowrap ${className}`}
            title={`Tipo: ${product.label}`}
        >
            <Icon className={compact ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
            <span>{product.label}</span>
        </span>
    );
}

export default ProductTypeBadge;
